import { gql } from 'apollo-boost';
import { useMutation } from '../';

export const mutation = gql`
  mutation updateContributionViews($id: Int!, $template: JSONString!, $name: String) {
    updateContributionViews(id: $id, template: $template, name: $name) {
      success
      id
    }
  }
`;

export function useUpdateContributionViews() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mutation, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
